import { clevertapEvent } from 'utils/clevertap';

export const VIRTUAL_TRADING_NAVIGATE = {
  buyOrderViewed: 'Buy Order Viewed',
  portfolioViewed: 'Portfolio Viewed',
  sellOrderViewed: 'Sell Order Viewed',
  portfolioOrderViewed: 'Portfolio Order Viewed',
  orderDetailViewed: 'Order Detail Viewed',
  amendOrderViewed: 'Amend Order Viewed',
};

export const VIRTUAL_TRADING_ACTION = {
  virtualTradingAction: 'Virtual Trading Action',
  startTradingSelected: 'Start Trading Selected',
  virtualTradingSelected: 'Virtual Trading Selected',
  switchToRealTradingSelected: 'Switch To Real Trading Selected',
  virtualTradingOrderbookSelected: 'Virtual Trading Orderbook Selected',
  virtualTradingPortfolioSelected: 'Virtual Trading Portfolio Selected',
  virtualTradingOrderSelected: 'Virtual Trading Order Selected',
  buyOrderPlaced: 'Buy Order Placed',
  buyOrderCanceled: 'Buy Order Canceled',
  portfolioBuyMoreSelected: 'Portfolio Buy More Selected',
  portfolioSellStockSelected: 'Portfolio Sell Stock Selected',
  portfolioViewChartSelected: 'Portfolio View Chart Selected',
  portfolioSetPriceAlert: 'Portfolio Set Price Alert Selected',
  portfolioStockSelected: 'Portfolio Stock Selected',
  sellOrderPlaced: 'Sell Order Placed',
  orderDetailCancelOrderSelected: 'Order Detail Cancel Order Selected',
  orderDetailAmendSelected: 'Order Detail Amend Selected',
  amendOrderPlaced: 'Amend Order Placed',
};

export const VIRTUAL_TRADING_TYPES = {
  virtualTrading: 'Virtual Trading',
  realTrading: 'Real Trading',
};

export const SYMBOL_TYPES = {
  right: 'Right',
  warrant: 'Warrant',
  normal: 'Normal',
};

export const VIRTUAL_TRADING_SOURCE = {
  watchlist: 'Watchlist',
  portfolio: 'Portfolio',
  predictionPost: 'Prediction Post',
  companyPage: 'Company Page',
  chartbit: 'Chartbit',
};

export const SWITCH_TO_REAL_ACCOUNT_SOURCE = {
  orderModal: 'Order Modal',
  dropdownVirtualArea: "Dropdown 'Virtual Area'",
};

export const ORDER_FILTER = {
  order: 'Order',
  exercise: 'Exercise',
  cashback: 'Cashback',
};

export const ORDER_EXPIRY = {
  goodForDay: 'Good for day',
  goodTillCanceled: 'Good till canceled',
};

export const PORTFOLIOS_TYPE = {
  regular: 'Regular',
  dayTrade: 'Day Trade',
  both: 'Both',
  none: 'None',
};

export const virtualTradingEvents = {
  onSwitchToVirtualTrading: (action = 'Switch To Virtual Selected') => {
    clevertapEvent(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
      Action: action,
    });
  },
};

export const virtualTradingNavigate = {
  onBuyOrderViewes: (Symbol, Source, Type) => {
    clevertapEvent(VIRTUAL_TRADING_NAVIGATE.buyOrderViewed, {
      Symbol,
      Source,
      Type,
    });
  },
  onPortfolioViewed: (Type) => {
    clevertapEvent(VIRTUAL_TRADING_NAVIGATE.portfolioViewed, {
      Type,
    });
  },
  onSellOrderViewed: (Symbol, Type) => {
    clevertapEvent(VIRTUAL_TRADING_NAVIGATE.sellOrderViewed, {
      Symbol,
      Type,
    });
  },
  onPortfolioOrderViewed: (Type) => {
    clevertapEvent(VIRTUAL_TRADING_NAVIGATE.portfolioOrderViewed, {
      Type,
    });
  },
  onOrderDetailViewed: ({
    OrderType,
    Status,
    RejectReason = '',
    Symbol,
    Type,
  }) => {
    clevertapEvent(VIRTUAL_TRADING_NAVIGATE.orderDetailViewed, {
      'Order Type': OrderType,
      Status,
      'Reject Reason': RejectReason,
      Symbol,
      Type,
      //   "Symbol Type": generateSymbolOptions(Symbol),
    });
  },
  onAmendOrderViewed: ({ Symbol, OrderType, Type }) => {
    clevertapEvent(VIRTUAL_TRADING_NAVIGATE.amendOrderViewed, {
      Symbol,
      'Order Type': OrderType,
      Type,
    });
  },
};

export const virtualTradingAction = {
  onStartTradingSelected: () => {
    clevertapEvent(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
      Action: VIRTUAL_TRADING_ACTION.startTradingSelected,
    });
  },
  onVirtualTradingSelected: (isStockbitSekuritas) => {
    clevertapEvent(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
      Action: VIRTUAL_TRADING_ACTION.virtualTradingSelected,
      'Is Stockbit Sekuritas': isStockbitSekuritas,
    });
  },
  onSwitchToRealTradingSelected: (Source, isStockbitSekuritas) => {
    clevertapEvent(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
      Action: VIRTUAL_TRADING_ACTION.switchToRealTradingSelected,
      Source,
      'Is Stockbit Sekuritas': isStockbitSekuritas,
    });
  },
  onVirtualTradingOrderbookSelected: () => {
    clevertapEvent(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
      Action: VIRTUAL_TRADING_ACTION.virtualTradingOrderbookSelected,
    });
  },
  onVirtualTradingPortfolioSelected: () => {
    clevertapEvent(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
      Action: VIRTUAL_TRADING_ACTION.virtualTradingPortfolioSelected,
    });
  },
  onVirtualTradingOrderSelected: () => {
    clevertapEvent(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
      Action: VIRTUAL_TRADING_ACTION.virtualTradingOrderSelected,
    });
  },
  onBuyOrderPlaced: ({ Symbol, Price, Lot, Type }) => {
    clevertapEvent(VIRTUAL_TRADING_ACTION.buyOrderPlaced, {
      Symbol,
      Price,
      Lot,
      Type,
    });
  },
  onBuyOrderCanceled: ({ Symbol, Price, Lot, Type }) => {
    clevertapEvent(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
      Action: VIRTUAL_TRADING_ACTION.buyOrderCanceled,
      Symbol,
      Price,
      Lot,
      Type,
    });
  },
  onPortfolioBuyMoreSelected: ({ Symbol, gainLossPercentage, Type }) => {
    clevertapEvent(VIRTUAL_TRADING_ACTION.portfolioBuyMoreSelected, {
      Symbol,
      'Gain / Loss %': gainLossPercentage,
      Type,
    });
  },
  onPortfolioSellStockSelected: (Type) => {
    clevertapEvent(VIRTUAL_TRADING_ACTION.portfolioSellStockSelected, {
      Type,
    });
  },
  onPortfolioViewChartSelected: (Symbol, Type) => {
    clevertapEvent(VIRTUAL_TRADING_ACTION.portfolioViewChartSelected, {
      Symbol,
      Type,
    });
  },
  onPortfolioSetPriceAlert: (Symbol, Type) => {
    clevertapEvent(VIRTUAL_TRADING_ACTION.portfolioSetPriceAlert, {
      Symbol,
      Type,
    });
  },
  onPortfolioStockSelected: (Symbol, Type) => {
    clevertapEvent(VIRTUAL_TRADING_ACTION.portfolioStockSelected, {
      Symbol,
      Type,
    });
  },
  onSellOrderPlaced: ({ Symbol, Price, gainLossPercentage, Type }) => {
    clevertapEvent(VIRTUAL_TRADING_ACTION.sellOrderPlaced, {
      Symbol,
      Price,
      'Gain / Loss %': gainLossPercentage,
      Type,
    });
  },
  onOrderDetailCancelOrderSelected: (Symbol) => {
    clevertapEvent(VIRTUAL_TRADING_ACTION.orderDetailCancelOrderSelected, {
      Symbol,
    });
  },
  onOrderDetailAmendSelected: ({ Symbol, Type }) => {
    clevertapEvent(VIRTUAL_TRADING_ACTION.orderDetailAmendSelected, {
      Symbol,
      Type,
    });
  },
  onAmendOrderPlaced: ({ Symbol, Price, Type }) => {
    clevertapEvent(VIRTUAL_TRADING_ACTION.amendOrderPlaced, {
      Symbol,
      Price,
      Type,
    });
  },
};
export default {
  virtualTradingEvents,
};
